module.exports = __webpack_public_path__ + "static/media/ic_host.08609872.svg";